import { render, staticRenderFns } from "./EmployeePassportCreateOrUpdate.vue?vue&type=template&id=48587098&"
import script from "./EmployeePassportCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeePassportCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports